import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const TravelClub: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      fill: 'none',
      width: '32px',
      height: '32px',
      ...sx,
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9993 6.66602C12.5419 10.3567 12.5419 16.3087 15.9993 19.9993C19.4566 16.3087 19.4566 10.3567 15.9993 6.66602Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 6.66602C19.6907 6.66602 22.6667 9.64202 22.6667 13.3327C22.6667 17.0233 19.6907 19.9993 16 19.9993"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0026 19.9993C12.3119 19.9993 9.33594 17.0233 9.33594 13.3327C9.33594 9.64202 12.3119 6.66602 16.0026 6.66602"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.33594 13.3327H22.6693" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7066 29.3327H8.2986C6.6626 29.3327 5.33594 28.006 5.33594 26.37V5.62868C5.33594 3.99268 6.6626 2.66602 8.2986 2.66602H23.7066C25.3426 2.66602 26.6693 3.99268 26.6693 5.62868V26.37C26.6693 28.006 25.3426 29.3327 23.7066 29.3327Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M20 24.6667H12" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);
